export const validatePrefix = (element) => {
  const valid = {
    isValid: true,
    message: "",
  };

  if (element === "") {
    valid.isValid = false;
    valid.message = "Prefix can not be empty";
  }

  return valid;
};



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Validation/PrefixValidation.js